export default {
    path : "factory-item-important",
    name : "factory-item-important",
    meta : {
        title : "重点接洽项目"
    },
    component: () => import('@/pages/factory/important/Index'),
    redirect: {
        name : "factory-item-important-whole"
    },
    children: [
        {
            path: 'all',
            name: 'factory-item-important-whole',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'recent',
            name: 'factory-item-important-recent',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'atme',
            name: 'factory-item-important-atme',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'meat',
            name: 'factory-item-important-meat',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'reply',
            name: 'factory-item-important-reply',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'search',
            name: 'factory-item-important-search',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/factory/importantitem/index.js